import { render, staticRenderFns } from "./ClienteCreditos.vue?vue&type=template&id=0b3c754c&scoped=true"
import script from "./ClienteCreditos.vue?vue&type=script&lang=js"
export * from "./ClienteCreditos.vue?vue&type=script&lang=js"
import style0 from "./ClienteCreditos.vue?vue&type=style&index=0&id=0b3c754c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c754c",
  null
  
)

export default component.exports